import React, { useState } from "react";
import CustomTooltip from "./CustomTooltip";

const CopyableText = ({
  text,
  textToCopy,
  label,
  className,
  style,
  tooltipText,
  component: Component = "div",
}) => {
  const [isHovered] = useState(false);
  const [isCopied, setIsCopied] = useState(false);

  const copyToClipboard = (e) => {
    e.stopPropagation();
    navigator.clipboard
      .writeText(textToCopy || text)
      .then(() => {
        console.log(`${label} copied:`, textToCopy || text);
        setIsCopied(true);
        // Reset the tooltip text after 2 seconds
        setTimeout(() => setIsCopied(false), 2000);
      })
      .catch((err) => console.error("Failed to copy:", err));
  };

  return (
    <div
      className={`d-flex align-items-center position-relative ${className}`}
      onClick={copyToClipboard}
      style={{ cursor: "pointer", ...style }}
    >
      <CustomTooltip
        content={isCopied ? "Text Copied!" : tooltipText || "Click to copy"}
      >
        <Component className="w-100">{text}</Component>
      </CustomTooltip>
      <i
        className="fas fa-copy ms-2"
        style={{
          opacity: isHovered ? 1 : 0,
          transition: "opacity 0.2s",
          fontSize: "0.8rem",
          color: "#6c757d",
          position: "absolute",
          right: "0",
          top: "50%",
          transform: "translateY(-50%)",
        }}
      />
    </div>
  );
};

export default CopyableText;
